import { render, staticRenderFns } from "./whatsapp-cloud.vue?vue&type=template&id=50c7a8e4&scoped=true"
import script from "./whatsapp-cloud.vue?vue&type=script&lang=js"
export * from "./whatsapp-cloud.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-cloud.vue?vue&type=style&index=0&id=50c7a8e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7a8e4",
  null
  
)

export default component.exports